import script from "./Transfer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Transfer.vue?vue&type=script&setup=true&lang=ts"

import "./Transfer.vue?vue&type=style&index=0&id=00a7d21c&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00a7d21c"]])

export default __exports__